import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import { zfd } from 'zod-form-data'

const openHoursSchema = z.object({
  sunday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
  monday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
  tuesday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
  wednesday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
  thursday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
  friday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
  saturday: z.object({ hours: z.array(z.object({ from: z.string(), to: z.string() })), open: z.boolean() }).optional(),
})

const schema = z.object({
  orgId: z.string(),
  name: z.string().min(1, { message: `Name is required` }),
  address: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  timezone: z.string().min(1, { message: `Timezone is required` }),
  zip: z.string().optional(),
  type: z.string().optional(),
  businessPhone: z.string().optional(),
  officeMainNumber: z.string().optional(),
  openHours: zfd.json(openHoursSchema).optional(),
})

export const editValidator = withZod(
  schema.extend({
    id: z.string(),
    workspaceId: zfd.text(),
  }),
)

export const createValidator = withZod(
  schema.extend({
    workspaceId: zfd.text(z.string({ error: `No workspace selected` })),
  }),
)
